<template>
  <main>
    <div class="content-box work-wrp fadeInUp">
        <h1 class="about-h1">Recent Projects</h1>
        <CarouselPlaceholder 
                v-if="!urls.length"
                customClasses="column"
            />
        <a 
          v-else
          v-for="(url,index) in urls"
          :key="index"
          class="work-img"
          :href="url.link"
          target="_blank"
        >
          <div class="overlay"></div>
          <div class="img-name-wrp">
            <p>{{url.name}}</p>
            <p>{{url.category}}</p>
          </div>
          <div class="visit">
              <span>Visit Site</span>
          </div>
          <img :src="url.list" :alt="url.name" width="1094" height="340">
        </a>
    </div>
    <about-footer
        :background="'#EDEDED'"
        :color="'#161717'"
      />
  </main>
</template>

<script>
import Footer from '../components/footer/Footer'
import http from '../api/requst'
import CarouselPlaceholder from '../components/carousel/CarouselPlaceholder'
export default {
  data(){
    return{
      urls:[]
    }
  },

  methods:{
    visibilityChanged(isVisible, entry){
      entry.target.setAttribute('data-isVisible',isVisible)
    }
  },

  mounted(){
    http('/projects').then(resp=>{
        this.urls = resp.data
        // for(let i = 0;i < 6; i++){
        //     //this.urls = resp.data
        //     this.urls.push(...resp.data)
        // }
    })
    .catch()
  },

  components:{
    AboutFooter:Footer,
    CarouselPlaceholder
  }
}
</script>

<style>
.work-wrp{
  padding-top: 2%;
  padding-bottom: 2%;
}

.work-wrp a{
  display: block;
  width: 100%;
  position: relative;
  max-height: 404px;
  height: 100%;
  margin: 3% 0;
  overflow: hidden;
  border-radius: 10px;
}

.work-wrp .overlay{
  position: absolute;
  width: 100%;
  height: 100%;
  background: #051F2C 0% 0% no-repeat padding-box;
  opacity: 0.43;
}

.work-wrp .img-name-wrp{
  position: absolute;
  width: 100%;
  display: flex;
  color: white;
  font-weight: 600;
  flex-direction: column;
  padding-top: 2%;
  padding-left: 3%;
}

.work-wrp .img-name-wrp p:first-child{
  font-size: 50px;
}

.work-wrp .img-name-wrp p:last-child{
  font-size: 30px;
  font-weight: 300;
}

.work-wrp .visit{
  width: 100%;
  display: flex;
  padding-left: 3%;
  bottom: 5%;
  transform: translateY(200%);
  transition: transform .2s ease;
  position: absolute;
}

.work-wrp .visit span{
  font-size: 24px;
  font-weight: 600;
  color: black;
  background: white;
  padding:14px 4%;
  text-align: center;
  border-radius: 37px;
}

.work-wrp a:hover .visit{
  transform: translateY(0);
}

.work-wrp img{
  height: 100%;
  width: 100%;
  object-fit: contain;
}

@media screen and (max-width: 800px){
  .work-wrp .img-name-wrp p:first-child{
    font-size: 40px;
  }

  .work-wrp .img-name-wrp p:last-child{
    font-size: 20px;
  }

  .work-wrp .visit span{
    font-size: 20px;
  }
}

@media screen and (max-width: 589px){
  .work-wrp .img-name-wrp p:first-child{
    font-size: 30px;
  }

  .work-wrp .visit span{
    font-size: 16px;
  }
}
</style>